import { Text, XStack } from 'tamagui';
import { Icon } from '../primitives/Icon';
import { colors } from '../theme/colors';

interface TimePillProps {
  startTime: string;
  endTime?: string | undefined;
  accentColor?: string | undefined;
  /** 'default' — colored text on tinted background (default).
   *  'overlay' — white text on dark background with clock icon, for photo overlays. */
  variant?: 'default' | 'overlay' | undefined;
}

export function TimePill({
  startTime,
  endTime,
  accentColor = colors.accentCerulean,
  variant = 'default',
}: TimePillProps) {
  const label = endTime ? `${startTime} – ${endTime}` : startTime;

  if (variant === 'overlay') {
    return (
      <XStack
        position="absolute"
        top={10}
        right={10}
        backgroundColor={colors.overlayDark}
        borderRadius={20}
        paddingHorizontal={10}
        paddingVertical={5}
        alignItems="center"
        gap={4}
      >
        <Icon name="schedule" size={12} color={colors.textOnDark} />
        <Text fontSize={12} fontWeight="700" color={colors.textOnDark}>
          {label}
        </Text>
      </XStack>
    );
  }

  const bgColor = accentColor + '1A';
  return (
    <XStack
      alignSelf="flex-start"
      paddingHorizontal={10}
      paddingVertical={3}
      borderRadius={100}
      borderWidth={1}
      backgroundColor={bgColor}
      borderColor={accentColor + '33'}
    >
      <Text fontSize={12} fontWeight="600" color={accentColor}>
        {label}
      </Text>
    </XStack>
  );
}
